module.exports = __webpack_public_path__ + "static/1st-tpm-1-03d4c107c41bcbeff8941f8475d9c66e.jpg";